import {Types} from "../actions/sidebarActions";
import _ from "lodash";
import {NotificationManager} from 'react-notifications';

import cleanDeep from 'clean-deep';


const defaultState = {
  sidebar: {}
};

const sidebarReducers = (state = defaultState, action) => {
  
console.log('hereSIDEBAR toggleTo',action.type)
  switch (action.type) {

    case Types.SIDEBAR_TOGGLE: {

      let newState = _.cloneDeep(state);

      console.log('toggleTo',!newState.sidebar.show)
      newState.sidebar.show = !newState.sidebar.show;

      return newState;
    }

    default:
      return state;
    }
};

export default sidebarReducers;